class User{
    
    constructor(user){
        this.user = user;
    }
    isAdministrator(){
        if(this.user.user_role == 'admin'){
            return true;
        }
        return false;
    }
    getProfileImage(){
        if(!this.user){
            return '';
        }
        return this.user.thumbnail ? this.user.thumbnail : "/images/profile.png"
    }
    getFullName(){
        if(this.user.first_name && this.user.last_name){
            return this.user.first_name+' '+this.user.last_name;
        }
        return '';
    }
    canAccess(permission_slug){
        if(!this.user){
            return false;
        }
        if(this.isAdministrator()){
            return true;
        }
        let isPermited = false;
        let roles = this.user.roles;
        roles.forEach(role => {
            role.permissions.forEach(permission => {
                if(permission.slug == permission_slug){
                    isPermited = true;
                }
            });
        });
        return isPermited;
    }
}

export default User;